import * as React from 'react';
import Select from 'react-select';
import Common from '../util/common';
import IconAdd from './IconAdd';
import styled from 'styled-components';
const header = (props) => {
    const common = new Common();
    const placeholder = props.appState.listId ? props.appState.listId : 'Select List...';
    const loadList = (listId) => {
        const loadListId = listId ? listId : props.appState.listId;
        props.handlers.loadList(loadListId);
    };
    const newListHandler = () => {
        props.handlers.loadList();
    };
    return (React.createElement(Header, null,
        React.createElement(HeaderLeft, null,
            React.createElement("h1", null, "Draft Assist")),
        React.createElement(HeaderRight, null,
            React.createElement(IconAdd, { className: "button", width: "30px", height: "30px", clicked: newListHandler }),
            React.createElement(Select, { onChange: (data) => { loadList(data.value); }, isSearchable: false, placeholder: placeholder, styles: common.selectStyles(), isMulti: false, options: common.listsForSelect() }))));
};
export default header;
const Header = styled.header `
  background-color: rgba(95,50,6,0.6);
  grid-area: header;
  display: flex;
  justify-content: space-between;
  padding: 15px;

  .button {
    cursor: pointer;
    height: 30px;
    margin-right: 10px;

    svg {
      fill: rgba(255, 255, 255, 0.5);
    }
  }
`;
const HeaderLeft = styled.div `
  flex-grow: 3;

  h1 {
    font-size: 1.5em;
    font-weight: normal;
    margin: 0;
    padding: 0;
  }
`;
const HeaderRight = styled.div `
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
`;
//# sourceMappingURL=Header.js.map


// WEBPACK FOOTER //
// ./src/components/Header.js